import React from "react"

function SafetyHelmet({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.6667 12.1333C21.2299 12.5091 22.6213 13.3995 23.6174 14.6616C24.6134 15.9236 25.1561 17.4839 25.1583 19.0916V20.6833H10.8417V19.0916C10.8395 17.4828 11.3805 15.9203 12.3773 14.6573C13.374 13.3944 14.768 12.505 16.3333 12.1333"
        stroke="#003E4C"
        strokeWidth="1"
        strokeMiterlimit="10"
      />
      <path
        d="M25.1583 20.6836H10.8417C9.96261 20.6836 9.25 21.3962 9.25 22.2753C9.25 23.1543 9.96261 23.8669 10.8417 23.8669H25.1583C26.0374 23.8669 26.75 23.1543 26.75 22.2753C26.75 21.3962 26.0374 20.6836 25.1583 20.6836Z"
        stroke="#003E4C"
        strokeWidth="1"
        strokeMiterlimit="10"
      />
      <path
        d="M20.3833 20.6833H15.6166L16.4083 11.1333H19.5916L20.3833 20.6833Z"
        stroke="#003E4C"
        strokeWidth="1"
        strokeMiterlimit="10"
      />
    </svg>
  )
}
export default SafetyHelmet
